import DownloadIcon from '@assets/icons/download.svg';
import { SORT_VALUES } from '../constants';

export const DROPDOWN_VALUES = {
  ALL: 'Download all',
  SELECTED: 'Download selected',
};

export const DROPDOWN_ITEMS = [
  {
    id: DROPDOWN_VALUES.ALL,
    value: DROPDOWN_VALUES.ALL,
    icon: <DownloadIcon width={16} />,
  },
];

export const SORT_ITEMS = [
  {
    value: 'Newest',
    id: SORT_VALUES.desc,
    isSelected: true,
  },

  {
    value: 'Oldest',
    id: SORT_VALUES.asc,
    isSelected: false,
  },
];
